<button class="item_add" (click)="add()">
    <fa-icon class="item-icon" icon="plus"></fa-icon>
</button>